"use strict";

exports.__esModule = true;
exports.defaultProps = void 0;
var defaultProps = {
  data: {
    paymentCalculatorLabel: 'PAYMENT CALCULATOR',
    vehicleName: '',
    msrpLabel: '',
    ctaText: '',
    ctaUrl: '',
    vehicles: []
  }
}; // eslint-disable-next-line import/prefer-default-export

exports.defaultProps = defaultProps;